import client from '@/apis/client';

export type LoginResult = {
  result: string;
  body?: {
    lockoutTimeRemaining?: number;
    loginFailCnt?: number;
  };
};

export const loginToDashboardApi = (userId: string) => client.get(`/shopl-chat/basic/dashboard/login/${userId}`);

export const loginApi = (formData: FormData) => client.post<LoginResult>('/shopl-chat/basic/login', formData);

export const logoutApi = () => client.post('/shopl-chat/basic/logout');

export const checkApi = () => client.post('/shopl-chat/basic/health');

export const getSalt = () => client.post<{ result: string; serverDatetime: string; serverTime: number }>('/datetime');
